import { render } from "./CrawlInvite.vue?vue&type=template&id=039d22a2&scoped=true"
import script from "./CrawlInvite.vue?vue&type=script&lang=js"
export * from "./CrawlInvite.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-039d22a2"

export default script